import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8l10 8l-5 4l0 -16l5 4l-10 8","key":"svg-0"}]]

/**
 * IconBluetooth
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYmx1ZXRvb3RoIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik03IDhsMTAgOGwtNSA0bDAgLTE2bDUgNGwtMTAgOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/bluetooth
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBluetooth = createReactComponent('outline', 'bluetooth', 'Bluetooth', __iconNode);

export default IconBluetooth;